module.exports = __webpack_public_path__ + "static/vwhead-light-05c402827f88db0dbd1d98b5689e7d71.woff2";